module.exports = __webpack_public_path__ + "img/pay4.99b92f90.png";